export default function Loader() {
  return (
    <div className="fixed inset-0 bg-black/60 z-[10000] flex items-center justify-center">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 375 375"
        width="250"
        height="250"
      >
        {/* Circle outline */}
        <path
          d="M 146.290958 -0.000712656
            C 65.494077 -0.000712656 -0.000718656 65.494083
            -0.000718656 146.290964
            C -0.000718656 227.082636 65.494077 292.577432
            146.290958 292.577432
            C 227.08263 292.577432 292.577426 227.082636
            292.577426 146.290964
            C 292.577426 65.494083 227.08263 -0.000712656
            146.290958 -0.000712656 Z"
          transform="matrix(0.75,0,0,0.75,77.781789,67.781784)"
          fill="none"
          stroke="orange"
          strokeWidth={10}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeDasharray="0,1000"
          strokeDashoffset="0"
        >
          <animate
            attributeName="stroke-dasharray"
            values="0,1000;1000,0;0,1000"
            keyTimes="0;0.5;1"
            dur="4s"
            repeatCount="indefinite"
          />
          <animate
            attributeName="stroke-dashoffset"
            from="0"
            to="-1000"
            dur="4s"
            repeatCount="indefinite"
          />
        </path>

        {/* Lightning paths with longer visible time */}
        <path
          d="M 2.500129 2.497523 L 164.303133 2.502442"
          transform="matrix(0.427633,-0.616141,0.616141,0.427633,147.020942,187.53491)"
          fill="none"
          stroke="orange"
          strokeWidth={5}
          strokeLinecap="round"
          strokeLinejoin="miter"
          strokeDasharray="200"
          strokeDashoffset="200"
        >
          <animate
            attributeName="stroke-dashoffset"
            values="200;0;0;200"
            keyTimes="0;0.2;0.8;1"
            dur="4s"
            repeatCount="indefinite"
          />
        </path>

        <path
          d="M 2.500157 2.499172 L 40.052242 2.499172"
          transform="matrix(0.75,0,0,0.75,148.562383,186.73109)"
          fill="none"
          stroke="orange"
          strokeWidth={5}
          strokeLinecap="round"
          strokeLinejoin="miter"
          strokeDasharray="50"
          strokeDashoffset="50"
        >
          <animate
            attributeName="stroke-dashoffset"
            values="50;0;0;50"
            keyTimes="0;0.2;0.8;1"
            dur="4s"
            repeatCount="indefinite"
            begin="0.2s"
          />
        </path>

        <path
          d="M 2.502425 2.500385 L 109.430245 2.498582"
          transform="matrix(0.225303,-0.715359,0.715359,0.225303,153.467836,268.109601)"
          fill="none"
          stroke="orange"
          strokeWidth={5}
          strokeLinecap="round"
          strokeLinejoin="miter"
          strokeDasharray="120"
          strokeDashoffset="120"
        >
          <animate
            attributeName="stroke-dashoffset"
            values="120;0;0;120"
            keyTimes="0;0.2;0.8;1"
            dur="4s"
            repeatCount="indefinite"
            begin="0.4s"
          />
        </path>

        <path
          d="M 2.500955 2.497672 L 160.496651 2.501087"
          transform="matrix(0.432529,-0.612714,0.612714,0.432529,154.71603,265.123929)"
          fill="none"
          stroke="orange"
          strokeWidth={5}
          strokeLinecap="round"
          strokeLinejoin="miter"
          strokeDasharray="200"
          strokeDashoffset="200"
        >
          <animate
            attributeName="stroke-dashoffset"
            values="200;0;0;200"
            keyTimes="0;0.2;0.8;1"
            dur="4s"
            repeatCount="indefinite"
            begin="0.6s"
          />
        </path>

        <path
          d="M 2.501145 2.501708 L 40.115731 2.501708"
          transform="matrix(0.75,0,0,0.75,194.788204,164.463563)"
          fill="none"
          stroke="orange"
          strokeWidth={5}
          strokeLinecap="round"
          strokeLinejoin="miter"
          strokeDasharray="50"
          strokeDashoffset="50"
        >
          <animate
            attributeName="stroke-dashoffset"
            values="50;0;0;50"
            keyTimes="0;0.2;0.8;1"
            dur="4s"
            repeatCount="indefinite"
            begin="0.8s"
          />
        </path>

        <path
          d="M 2.501625 2.498836 L 109.938588 2.49909"
          transform="matrix(0.222403,-0.713209,0.713209,0.222403,192.997374,165.779214)"
          fill="none"
          stroke="orange"
          strokeWidth={5}
          strokeLinecap="round"
          strokeLinejoin="miter"
          strokeDasharray="120"
          strokeDashoffset="120"
        >
          <animate
            attributeName="stroke-dashoffset"
            values="120;0;0;120"
            keyTimes="0;0.2;0.8;1"
            dur="4s"
            repeatCount="indefinite"
            begin="1s"
          />
        </path>
      </svg>
    </div>
  );
}
